import type { BlogPost } from './types'

export const LOKALE_KI_MODELLE_PHOTOVOLTAIK: BlogPost = {
  slug: 'lokale-ki-modelle-photovoltaik',
  lang: 'de',
  topicId: 'lokale-ki-modelle-photovoltaik',
  title: 'Lokale KI-Modelle zuhause betreiben: Was das für Ihren Stromverbrauch bedeutet',
  metaDescription:
    'Ein eigener KI-/GPU-Server für lokale Sprachmodelle zieht real spürbar Strom - was das für ' +
    'die passende PV-Anlagengröße bedeutet. Stand: August 2026.',
  keywords: [
    'ki server zuhause stromverbrauch',
    'lokale ki modelle photovoltaik',
    'ki modelle zuhause betreiben',
    'gpu server photovoltaik',
    'homelab solarstrom',
  ],
  publishedAt: '2026-08-05',
  excerpt:
    'Ein eigener Rechner für lokale KI-Modelle spart Cloud-Kosten und schützt Daten - zieht aber ' +
    'real spürbar Strom, oft im Dauerbetrieb. Was das für die passende Photovoltaik-Anlagengröße ' +
    'bedeutet und worauf Sie achten sollten.',
  sections: [
    {
      type: 'paragraph',
      text:
        'Lokale KI-Modelle auf eigener Hardware zu betreiben, statt jede Anfrage über eine ' +
        'Cloud-API abzurechnen, wird zunehmend beliebter - kein Datenabfluss an Dritte, keine ' +
        'laufenden Kosten pro Anfrage, oft auch schnellere Antwortzeiten als über einen externen ' +
        'Dienst. Was in dieser Diskussion bisher kaum vorkommt: der reale Stromverbrauch einer ' +
        'solchen Hardware - und was das für Besitzer einer Photovoltaikanlage (oder alle, die eine ' +
        'planen) bedeutet.',
    },
    {
      type: 'heading',
      text: 'Wie viel Strom zieht ein KI-Server wirklich?',
    },
    {
      type: 'paragraph',
      text:
        'Eine einzelne High-End-Grafikkarte wie die RTX 4090 ist laut Herstellerangabe mit 450 W TGP ' +
        '(Total Graphics Power) spezifiziert, bei 850 W empfohlener Mindest-Systemleistung fürs ' +
        'Gesamtsystem. Wer für größere Modelle mehrere solcher Karten kombiniert, kommt schnell auf ' +
        'ein Vielfaches davon. Anders als ein Gaming-PC, der meist nur stundenweise unter Volllast ' +
        'läuft, wird ein KI-Server für Inferenz oder Training häufig über lange Zeiträume oder sogar ' +
        'dauerhaft betrieben - das macht ihn potenziell zum größten Einzelverbraucher im Haushalt, ' +
        'noch vor Wärmepumpe oder E-Auto-Ladung.',
    },
    {
      type: 'heading',
      text: 'Was das für Ihre PV-Anlagengröße bedeutet',
    },
    {
      type: 'paragraph',
      text:
        'Roofora modelliert diesen Verbrauchstreiber nicht als eigene Kennzahl - anders als bei ' +
        'Wärmepumpe oder Elektroauto gibt es dafür keine eigene Eingabe im Anfrage-Wizard, weil es ' +
        'keine belastbare, allgemeingültige Watt-Angabe für "einen KI-Server" gibt (die Bandbreite ' +
        'reicht von einer einzelnen gebrauchten Grafikkarte bis zu mehreren High-End-Karten im ' +
        'Dauerbetrieb). Der ehrliche Weg: schätzen Sie Ihren tatsächlichen Jahresverbrauch inklusive ' +
        'der Server-Laufzeit selbst ab und geben Sie diese Zahl beim PV-Rechner bzw. beim ' +
        'PV-Kostenrechner an - die Anlagengröße wird dann auf Basis Ihres tatsächlichen ' +
        'Gesamtverbrauchs empfohlen, nicht auf Basis einer erfundenen Pauschale für KI-Hardware.',
    },
    {
      type: 'heading',
      text: 'Ein Rechenbeispiel zur Einordnung',
    },
    {
      type: 'paragraph',
      text:
        'Eine einzelne Karte mit 450 W TGP, die im Schnitt 8 Stunden täglich unter Last läuft, kommt ' +
        'allein dadurch auf rund 1.300 kWh Mehrverbrauch im Jahr - das ist eine illustrative ' +
        'Überschlagsrechnung mit den oben genannten Herstellerangaben, keine für Ihren konkreten ' +
        'Aufbau gültige Zahl. Ihre tatsächliche Laufzeit, Karten-Anzahl und Auslastung bestimmen den ' +
        'realen Wert.',
    },
    {
      type: 'heading',
      text: 'Warum sich Solarstrom hierfür besonders lohnt',
    },
    {
      type: 'paragraph',
      text:
        'Wer die Trainings- oder Batch-Inferenz-Läufe zeitlich flexibel legen kann, profitiert davon, ' +
        'diese bevorzugt in die sonnenreichen Stunden zu verschieben - ähnlich wie beim Laden eines ' +
        'Elektroautos. Ein Dauerbetrieb rund um die Uhr lässt sich dagegen nur teilweise durch PV ' +
        'allein decken; ein Batteriespeicher hilft, auch außerhalb der Sonnenstunden mit ' +
        'selbst erzeugtem Strom statt teurem Netzstrom zu versorgen.',
    },
    {
      type: 'heading',
      text: 'Wichtiger Hinweis',
    },
    {
      type: 'paragraph',
      text:
        'Alle Watt- und kWh-Angaben in diesem Beitrag stammen aus öffentlichen Hersteller- bzw. ' +
        'Marktangaben (Stand August 2026) und sind allgemeiner Natur, keine für Ihren konkreten ' +
        'Aufbau berechnete Zahl. Für eine realistische Einschätzung Ihres individuellen Bedarfs ' +
        'nutzen Sie am besten den PV-Rechner mit Ihrem tatsächlich geschätzten Jahresverbrauch.',
    },
  ],
  relatedLinks: [
    { label: 'Was kostet eine Solaranlage?', href: '/solaranlage-kosten' },
    { label: 'Kostenlos die passende Anlagengröße berechnen', href: '/pv-rechner' },
    { label: 'PV-Kostenrechner: Durchschnittspreis in Sekunden', href: '/pv-kostenrechner' },
  ],
}
